import type { FaireProductEntity } from "../../entity_types/product";

export const p_4mpaxtvdb7: FaireProductEntity = {
  token: "p_4mpaxtvdb7",
  type: "product",
  name: "OKloveyoubye Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/18f3df01acd5ada2c3957e71f982d702cc57dd393ef66d94d07ff4404268b44e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a0579faece6fda3f8d514f5132a473ff3a2f018e8cf5bbcc915fbb0c3571c2bc.jpeg",
    "https://cdn.faire.com/fastly/495414290848cf5dc907ac990d1681208c353fc2fe5c09b35d05bfd13c65c22e.jpeg",
    "https://cdn.faire.com/fastly/0cb7ba8cc8107a93d2666ff1d9df160ecf8155de7624f182c817d8c08e5071af.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:31.176Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
